import { render, staticRenderFns } from "./DialogFormacoesDoMes.vue?vue&type=template&id=1469bbe7"
import script from "./DialogFormacoesDoMes.vue?vue&type=script&lang=js"
export * from "./DialogFormacoesDoMes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports